var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("loyalty-card"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { lg: "6", xs: "12" } },
                                    [
                                      _c(
                                        "w-settings-group",
                                        {
                                          attrs: {
                                            title: _vm.$ct(
                                              "loyalty.titles.general"
                                            ),
                                          },
                                        },
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              label: _vm.$ct("loyalty.enabled"),
                                            },
                                            model: {
                                              value: _vm.config.Enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "Enabled",
                                                  $$v
                                                )
                                              },
                                              expression: "config.Enabled",
                                            },
                                          }),
                                          _c("w-checkbox", {
                                            attrs: {
                                              label: _vm.$ct(
                                                "loyalty.always-show-button"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.config.AlwaysShowButton,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "AlwaysShowButton",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.AlwaysShowButton",
                                            },
                                          }),
                                          _c("w-input-number", {
                                            staticClass: "mts",
                                            attrs: {
                                              decimals: 2,
                                              label: _vm.$ct(
                                                "loyalty.points-per-euro"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.config.PointsPerEuro,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "PointsPerEuro",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.PointsPerEuro",
                                            },
                                          }),
                                          _c("app-sale-type-multi-select", {
                                            staticClass: "mts",
                                            attrs: {
                                              "use-id": "",
                                              fancy: "",
                                              "ignored-type-ids": [2],
                                              label: _vm.$ct(
                                                "loyalty.earn-sale-types"
                                              ),
                                            },
                                            model: {
                                              value: _vm.config.EarnSaleTypeIDs,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "EarnSaleTypeIDs",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.EarnSaleTypeIDs",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-settings-group",
                                        {
                                          attrs: {
                                            title: _vm.$ct(
                                              "loyalty.titles.redeem"
                                            ),
                                          },
                                        },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              label: _vm.$ct(
                                                "loyalty.redeem-step-points"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value:
                                                _vm.config.RedeemStepPoints,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "RedeemStepPoints",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.RedeemStepPoints",
                                            },
                                          }),
                                          _c("w-input-number", {
                                            staticClass: "mts",
                                            attrs: {
                                              decimals: 2,
                                              label: _vm.$ct(
                                                "loyalty.redeem-step-euro"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.config.RedeemStepEuro,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.config,
                                                  "RedeemStepEuro",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "config.RedeemStepEuro",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { lg: "6", xs: "12" } },
                                    [
                                      _c(
                                        "w-settings-group",
                                        {
                                          attrs: {
                                            title: _vm.$ct(
                                              "loyalty.titles.exclusions"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "exclusion-info" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ct(
                                                    "loyalty.exclusions-info"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("app-product-sku-autocomplete", {
                                            staticClass: "mts",
                                            attrs: { "allow-multiple": true },
                                            on: {
                                              multiple: function ($event) {
                                                return _vm.onProductSelect(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                return _vm.onSingleProduct(
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "group-wrap" },
                                            [
                                              _c("app-product-edit-groups", {
                                                staticClass: "mts",
                                                attrs: {
                                                  product: _vm.product,
                                                  light: true,
                                                },
                                                on: {
                                                  group: function ($event) {
                                                    return _vm.setMainGroup(
                                                      $event
                                                    )
                                                  },
                                                  subgroup: function ($event) {
                                                    ;(_vm.product.MainGroup =
                                                      null),
                                                      (_vm.product.GroupID =
                                                        $event)
                                                  },
                                                },
                                              }),
                                              _c(
                                                "w-button",
                                                {
                                                  staticClass: "mt",
                                                  attrs: { round: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onGroupSubmit()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("w-fa", {
                                                    attrs: { icon: "check" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-list",
                                            { staticClass: "mts" },
                                            [
                                              _vm._l(
                                                _vm.config.ExclusionFilters,
                                                function (item, i) {
                                                  return _c("app-filter-item", {
                                                    key: item.key,
                                                    attrs: {
                                                      expand:
                                                        _vm.openedCondition ==
                                                        item,
                                                    },
                                                    on: {
                                                      edit: function ($event) {
                                                        return _vm.editItem(
                                                          item
                                                        )
                                                      },
                                                      delete: function (
                                                        $event
                                                      ) {
                                                        return _vm.deleteItem(i)
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.config
                                                          .ExclusionFilters[i],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.config
                                                            .ExclusionFilters,
                                                          i,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "config.ExclusionFilters[i]",
                                                    },
                                                  })
                                                }
                                              ),
                                              _vm.config.ExclusionFilters
                                                .length == 0
                                                ? _c(
                                                    "w-list-item",
                                                    [
                                                      _c("w-list-item-text", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "common.empty-list"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "w-list-item",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addNewFilter()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "w-list-item-icon",
                                                    [
                                                      _c("w-fa", {
                                                        attrs: { icon: "plus" },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("w-list-item-text", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ct("common.add")
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }